export const SIMPLE_AVERAGE_GET_CYCLE_MENU_OPTIONS = 'GET_CYCLE_MENU_OPTIONS';
export const SIMPLE_AVERAGE_LOADING = 'SIMPLE_AVERAGE_LOADING';
export const SIMPLE_AVERAGE_GET_CYCLE_MENU_OPTIONS_ERROR =
  'SIMPLE_AVERAGE_GET_CYCLE_MENU_OPTIONS_ERROR';



// WEBPACK FOOTER //
// ./src/pages/simpleaverage/state/simpleaverage/types.js